// Verivox redirect URL configuration
const VERIVOX_PARTNER_SCRIPT_PATH = 'She6kUekQgXwm6H0M3bc7Q';
const VERIVOX_REDIRECT_BASE_URL = `https://partner.vxcp.de/ps/${VERIVOX_PARTNER_SCRIPT_PATH}/redirect.php`;
const DEFAULT_TOTAL_USAGE = 2500; // kWh per year

/**
 * Builds a Verivox redirect URL that forwards to the Verivox calculator
 * @param postalCode - User's postal code
 * @param locationId - Selected location ID
 * @param totalUsage - Annual electricity usage in kWh (default: 2500)
 * @param subPartnerId - Sub partner ID for tracking (default: '5762')
 * @param campaignId - Campaign ID for tracking (default: '2')
 * @returns Verivox redirect URL
 */
export function buildVerivoxRedirectUrl(
	postalCode: string,
	locationId: string,
	totalUsage: number = DEFAULT_TOTAL_USAGE,
	subPartnerId: string = '5762',
	campaignId: string = '2',
): string {
	const params = new URLSearchParams({
		productType: 'electricity',
		vxcp_TotalUsage: totalUsage.toString(),
		vxcp_PostCode: postalCode.trim(),
		vxcp_LocationID: locationId,
		vxcp_subPartnerId: subPartnerId,
		vxcp_campaignId: campaignId,
	});

	return `${VERIVOX_REDIRECT_BASE_URL}?${params.toString()}`;
}
